import * as UserActionTypes from '../constants/user/ActionTypes';

export const updateUserRole = (role) => ({
    type: UserActionTypes.UPDATE_ROLE,
    role
});
